import axios from "axios";
import { Fragment, PropsWithChildren } from "react";
import { ToastContainer } from "react-toastify";

import useErrorHandler from "./useErrorHandler";

import styles from "./ErrorHandler.module.scss";

const ErrorHandler = (props: PropsWithChildren) => {
  useErrorHandler(axios);

  return (
    <Fragment>
      <ToastContainer
        autoClose={10000}
        newestOnTop
        toastClassName={styles.NotificationToast}
        progressClassName={styles.NotificationProgressBar}
      />
      {props.children}
    </Fragment>
  );
};

export default ErrorHandler;
